export const subscriptions = {
  successMessage: '',
};
